import { useEffect, useState } from 'react';

interface SiteNavProps {
  onSearch: (q: string) => void;
}

const navLinks = [
  { href: '#hero', label: '首页' },
  { href: '#hot', label: '热门连载' },
  { href: '#category', label: '主题分类' },
  { href: '#update', label: '最新更新' },
  { href: '#featured', label: '编辑推荐' },
  { href: '#faq', label: '常见问题' },
];

export default function SiteNav({ onSearch }: SiteNavProps) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query);
    setOpen(false);
    document.querySelector('#hot')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || open ? 'bg-background-50/95 shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" aria-label="漫画韩国下拉式首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg" />
          </span>
          <span className="font-heading text-lg md:text-xl text-foreground-950">
            漫画韩国<span className="text-primary-600">下拉式</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSubmit} className="hidden lg:flex items-center gap-2 rounded-full bg-background-100 px-3 py-1.5">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索连载名称…"
              className="w-40 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="搜索连载"
            />
          </form>
          <button
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <form onSubmit={handleSubmit} className="mt-3 flex items-center gap-2 rounded-full bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索连载名称…"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="搜索连载"
            />
          </form>
          <ul className="mt-2 flex flex-col">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}